export default __webpack_public_path__ + "static/media/about.cee91e3e.png";